import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { ORM } from 'utility-ts-orm';
import { IPlanFeedbackSuggestion } from '../../plan_feedback/builders/plan_feedback_transaction_type';
import { IPlanFeebackCourseGroupsDatasource } from '../../plan_feedback/datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../../plan_feedback/datasources/plan_feedback_courses_datasource';
import { IPlanFeedbackProgramSlotsDatasource } from '../../plan_feedback/datasources/plan_feedback_program_slots_datasource';
import { IPlanFeebackTermsDatasource } from '../../plan_feedback/datasources/plan_feedback_terms_datasource';
import { PlanFeedbackServant } from '../../plan_feedback/servants/plan_feedback_servant';
import { ConflictingSuggestionsModel } from '../models/conflicting_suggestions_model';

export class AdvisorBlockedSuggestionsQuery implements IQuery {
  private __result: any;

  constructor(
    private ngConflictingSuggestionsModel: ConflictingSuggestionsModel,
    QueryMediator: IQueryMediator,
    private ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource,
    private ngPlanFeebackCoursesDatasource: IPlanFeebackCoursesDatasource,
    private ngPlanFeebackCourseGroupsDatasource: IPlanFeebackCourseGroupsDatasource,
    private ngPlanFeedbackProgramSlotsDatasource: IPlanFeedbackProgramSlotsDatasource
  ) {
    QueryMediator.registerQuery(this, ngConflictingSuggestionsModel);
  }

  run(): this {
    const conflictingIds = this.ngConflictingSuggestionsModel.read().conflicting_resolution_ids;
    const conflictingIdObj = _4.zipObject(conflictingIds, conflictingIds);

    const partitionSuggestions = (suggestion: IPlanFeedbackSuggestion) =>
      suggestion.resolution && conflictingIdObj[suggestion.resolution] === suggestion.resolution;

    const feedbackCourses = this.ngPlanFeebackCoursesDatasource
      .metasource()
      .derived()
      .filter((feedbackCourse) => PlanFeedbackServant.isValidFeedback(feedbackCourse));

    const [conflictingCourseSuggestions, acceptableCourseSuggestions] = _4.partition(
      feedbackCourses,
      partitionSuggestions
    );

    const feedbackCourseGroups = this.ngPlanFeebackCourseGroupsDatasource
      .metasource()
      .derived()
      .filter((feedbackCourse) => PlanFeedbackServant.isValidFeedback(feedbackCourse));

    const [conflictingCourseGroupsSuggestions, acceptableCourseGroupsSuggestions] = _4.partition(
      feedbackCourseGroups,
      partitionSuggestions
    );

    const feedbackProgramSlots = this.ngPlanFeedbackProgramSlotsDatasource
      .values()
      .filter((feedback) => PlanFeedbackServant.isValidFeedback(feedback));

    const [conflictingProgramSlotsSuggestions, acceptableProgramSlotsSuggestions] = _4.partition(
      feedbackProgramSlots,
      partitionSuggestions
    );

    const conflictingSuggestions = PlanFeedbackServant.getSuggestionsForCourseGroups(conflictingCourseGroupsSuggestions)
      .concat(PlanFeedbackServant.getSuggestionsForCourses(conflictingCourseSuggestions))
      .concat(PlanFeedbackServant.getSuggestionsForProgramSlots(conflictingProgramSlotsSuggestions));
    const acceptableSuggestions = PlanFeedbackServant.getSuggestionsForCourseGroups(acceptableCourseGroupsSuggestions)
      .concat(PlanFeedbackServant.getSuggestionsForCourses(acceptableCourseSuggestions))
      .concat(PlanFeedbackServant.getSuggestionsForProgramSlots(acceptableProgramSlotsSuggestions));
    this.__result = {
      conflictingSuggestions,
      acceptableSuggestions
    };
    return this;
  }

  get result() {
    return this.__result;
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngAPAdvisorBlockedSuggestionsQuery', AdvisorBlockedSuggestionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/queries/blocked_suggestions_query.ts